export default {
  methods: {
    computeResize: function (wWidth, wheight, rate) {
      var imgWidth = wWidth / wheight > rate ? wWidth + 'px' : 'auto'
      var imgHeight = wWidth / wheight < rate ? wheight + 'px' : 'auto'
      var top
      var margin
      if (imgWidth === 'auto') {
        margin = -(wheight * rate - wWidth) / 2 + 'px'
      } else {
        margin = '0px'
      }
      if (imgHeight === 'auto') {
        top = -(wWidth / rate - wheight) / 2 + 'px'
      } else {
        top = 0 + 'px'
      }
      return [imgWidth, imgHeight, margin, top]
    }
  }
}
